export const FAQ_QUESTION = 'question_json';
export const FAQ_ANSWER = 'answer_json';
